import React from 'react';
import UniversalAddItemForm from '../shared/UniversalAddItemForm';

const AddItemToAvoirForm = ({ refAvoir, onSuccess, codeEnt }) => {
  return (
    <UniversalAddItemForm
      refField="REF_AVR"
      refValue={refAvoir}
      onSuccess={onSuccess}
      codeEnt={codeEnt}
      priceType="selling"
      useNegativeTotals={true}
      enableBatch={true}
      useArticleList={false}
      submitButtonText="Add all to Avoir"
    />
  );
};

export default AddItemToAvoirForm;
